import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgOptimizedImage } from '@angular/common'

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AfterDateDirective } from '../directives/afterDateDirective';
import { OnlyNumbersDirective } from '../directives/onlyNumberDirective';

// Modules
import { MaterialModule } from './material.module';
import { DevExtremeModule } from './devextreme.module';

import 'reflect-metadata';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    DevExtremeModule,
    PdfViewerModule,
    NgOptimizedImage
  ],
  declarations: [
    AfterDateDirective,
    OnlyNumbersDirective
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi())
  ],
  exports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    DevExtremeModule,
    PdfViewerModule,
    NgOptimizedImage,
    AfterDateDirective,
    OnlyNumbersDirective
  ]
})
export class SharedModule {
  constructor() {
  }
}

